import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { TypeaheadMatch } from "ngx-bootstrap";
import { ControlContainer } from "@angular/forms";
import { DipendenteVO } from "@app/shared/vo/dipendenteVO";
import { OrganoService } from "@app/shared/services/organo.service";
import { isNullOrUndefined } from "util";

@Component({
  selector: "app-ricerca-dipendenti",
  templateUrl: "./ricerca-dipendenti.component.html",
})
export class RicercaDipendentiComponent implements OnInit {
  public typeaheadLoading: boolean;
  public typeaheadNoResults: boolean;
  public asyncDipSelected: string;
  public dataSourceDip: Observable<any>;
  public classificaBool: boolean = false;
  public formGroup;
  public readOnly = false;
  @Output()
  emettiDipendente: EventEmitter<DipendenteVO> = new EventEmitter<DipendenteVO>();
  dipendente: DipendenteVO;

  @Input()
  labelDip: string;


  constructor(
    private organoService: OrganoService
  ) {
    this.dataSourceDip = Observable.create((observer: any) => {
      observer.next(this.asyncDipSelected);
    }).pipe(
      switchMap((token: string) =>
        this.organoService.getDipendenti(String(token))
      )
    );
  }

  ngOnInit(): void {

  }

  public changeTypeaheadLoading(e: boolean): void {
    this.typeaheadLoading = e;
  }

  public changeTypeaheadNoResults(e: boolean): void {
    this.typeaheadNoResults = e;
  }

  public typeaheadDipOnSelect(e: TypeaheadMatch): void {
    this.emettiDipendente.emit(this.impostaDipendente(e.item.nome, e.item.cognome, e.item.cmu, e.item.cf));
  }
  public setDipendente(dipendente: DipendenteVO, refresh:boolean = true): void {
    this.dipendente = dipendente;
    if (this.dipendente) {
      this.dipendente.output = this.dipendente.nome + " " + this.dipendente.cognome;
      if (!isNullOrUndefined(this.dipendente.cmu) && this.dipendente.cmu.length) {
        this.dipendente.output += " - " + this.dipendente.cmu;
      }
    } else {
      this.dipendente = <DipendenteVO>{ output: "" };
    }
    if(refresh){
      //this.asyncDipSelected = this.dipendente.output
    }
  }
  private impostaDipendente(
    nome: string,
    cognome: string,
    cmu: string,
    cf: string
  ): DipendenteVO {

    this.setDipendente(<DipendenteVO>{
      cognome: cognome,
      nome: nome,
      cmu: cmu,
      cf: cf
    }, false);

    return this.dipendente;
  }

  public changeTypeaheadDipNoResults(e: boolean): void {
    this.typeaheadNoResults = e;
  }
}
